import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';

const dataProviderName = 'campaigns/campaign';
const wizardAction = 'operatorAutoAssociation'

const OperatorAssignation = ({ campaignId, setSelected }) => {
    const { t } = useTranslation();
    const { doAction } = useDataProvider(dataProviderName);
    const [loading, setLoading] = useState();

    const handleOperatorAssignation = () => {
        setLoading(true);
        doAction({
            action: wizardAction,
            model: dataProviderName,
            data: { campaignId: campaignId }
        }).then(() => {
            setLoading(false);
            setSelected([]);
        });
    };

    return [
        <>
            <Button
                onClick={handleOperatorAssignation}
                label={t("Auto Assegna")}
                icon="faPeopleArrows"
                family="fas"
                variant="solid"
                size="small"
                className="button-select"
                loading={loading}
            />
        </>
    ];
};

export default OperatorAssignation;
